//#region import
import React, { Fragment, createContext, useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, ConvertDateToUnixOrNull, DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectMonitorType, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnDraft, BtnEdit, BtnSave, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import { SelectItem } from 'components/Input/Select/SelectItem';
import AccordionPanel from '../components/AccordionPanel';
import { DateRangePickerItem } from 'components/Input/DatePicker/DateRangePickerItem';
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import moment from 'moment';
import DateRangePickerProject from '../components/DateRangePickerProject';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { useLocation } from 'react-router';
//#endregion

const Panel12 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel6,
        setisChangePanel6,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [arrDataMonitorTypeID, setarrDataMonitorTypeID] = useState([]);
    const [arrDataProjectTeamID, setarrDataProjectTeamID] = useState([]);
    const currentDate = new Date(); // Get the current date
    const [_dStart, setdStart] = useState(null); //01/01/New + 1
    const [_dEnd, setdEnd] = useState(null); //31/12/New + 1

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        GetFormInitial();
    }, []);    

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial(); handleGetFormProjectID();
    }, [nProjectID]);

    useEffect(() => {
        if (isChangePanel12 === true) GetFormInitial();
    }, [isChangePanel12]);    

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectPanel12, {nProjectID : nProjectID}, (result) => {
            setarrDataMonitorTypeID(result.lstMonitorTypeID);
            setarrDataProjectTeamID(result.lstProjectTeamID);
            setdStart(new Date(result.nStartDate));
            setdEnd(new Date(result.nEndDate));
            let sDateStart = result.isDatePanel6 === true ? new Date(result.nStartDate) : null;
            let sDateEnd = result.isDatePanel6 === true ? new Date(result.nEndDate) : null;
            formStart.setValue("sDateStart_Start", sDateStart);
            formStart.setValue("sDateEnd_Start", sDateEnd);
            formProceed.setValue("sDateStart_Proceed", sDateStart);
            formProceed.setValue("sDateEnd_Proceed", sDateEnd);
            formEnd.setValue("sDateStart_End", sDateStart);
            formEnd.setValue("sDateEnd_End", sDateEnd);            
            setisChangePanel12(false);
            // handleGetTableProject(dataRow);
        });
    }

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel12, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            
            setarrProjectMonitor_Start(result.objResult.lstProjectMonitor_Start); //105 ระยะเริ่มต้นโครงการ
            setDataRowStart({
                ...initRows,
                nDataLength: result.objResult.lstProjectMonitor_Start.length,
                arrRows: result.objResult.lstProjectMonitor_Start,
            });

            setarrProjectMonitor_Proceed(result.objResult.lstProjectMonitor_Proceed); //106 ระหว่างดําเนินการ
            setDataRowProceed({
                ...initRows,
                nDataLength: result.objResult.lstProjectMonitor_Proceed.length,
                arrRows: result.objResult.lstProjectMonitor_Proceed,
            });

            setarrProjectMonitor_End(result.objResult.lstProjectMonitor_End); //107 สิ้นสุดโครงการ
            setDataRowEnd({
                ...initRows,
                nDataLength: result.objResult.lstProjectMonitor_End.length,
                arrRows: result.objResult.lstProjectMonitor_End,
            });
        });
    };

    //#region Monitor Start
    const [nProjectMonitor_StartIDEdit, setnProjectMonitor_StartIDEdit] = useState(0);
    const [ObjStartIDEdit, setObjStartIDEdit] = useState(null);
    const [arrProjectMonitor_Start, setarrProjectMonitor_Start] = useState([]);
    const [DataRowStart, setDataRowStart] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formStart = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sActivity_Start: null, 
            // dProjectDateRange_Start: [null, null],
            nProjectTeamID_Start: null,
            sDescription_Start: null,
            sDateStart_Start: null,
            sDateEnd_Start: null,
        } as any,
    });

    const dataColumnStart: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Start_" + item.row.sID}
                                id={"btnDelete_Start_" + item.row.sID}
                                onClick={() => onDeleteStart(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_Start_" + item.row.sID}
                                id="btnEdit"
                                onClick={() => onEditStart(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Start_" + item.row.sID}
                            id="btnView"
                            onClick={() => onEditStart(item.row, EnumStatusMode.View)}
                            // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "sActivity",
            headerName: "กิจกรรม",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "nStartDate",
            headerName: "ระยะเวลา",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                // let sDate = moment(item.row.nStartDate).format("DD MMMM YYYY") + " - " + moment(item.row.nEndDate).format("DD MMMM YYYY");
                let sDate = Convert.DateTimeToString(item.row.nStartDate, "MMMM YYYY", "th") + " - " + Convert.DateTimeToString(item.row.nEndDate, "MMMM YYYY", "th");
                return (sDate);
            },
        },      
        {
            field: "sProjectTeamName",
            headerName: "ผู้รับผิดชอบ/หน่วยงาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },       
    ];

    const onAddStart = () => {
        let oForm = formStart.getValues();
        let ObjDuplicate = arrProjectMonitor_Start.filter((f) => !f.isDelete && (nProjectMonitor_StartIDEdit !== 0 ? f.nID !== nProjectMonitor_StartIDEdit : true) && f.sActivity === oForm.sActivity);
        if ((ObjDuplicate || []).length === 0)
        {      
            //#region Old
            // let nProjectMonitorID = 0;
            // let dataRow = DataRowStart;
            // let arrStart = DefaultArrayEmpty(arrProjectMonitor_Start);
            // let nMaxID = new LINQ<any>(arrStart).Any() ? new LINQ<any>(arrStart).Max((m) => m.nID) + 1 : 1;
            // if (nProjectMonitor_StartIDEdit) {
            //     arrStart = arrStart.filter((f) => f.nID !== nProjectMonitor_StartIDEdit);
            //     nProjectMonitorID = arrProjectMonitor_Start.find((f) => f.nID === nProjectMonitor_StartIDEdit)?.nProjectMonitorID;
            //     nMaxID = nProjectMonitor_StartIDEdit;
            // }
            // let sProjectTeamName = "";
            // let nProjectTeamID = Convert.StringToInt(oForm.nProjectTeamID_Start);
            // let ObjTeam = new LINQ<any>(arrDataProjectTeamID).FirstOrDefault(f=> f.value === nProjectTeamID) ?? null;
            // if(ObjTeam) sProjectTeamName = ObjTeam.label;

            // let dDateStart = oForm.sDateStart_Start ? moment(oForm.sDateStart_Start) : null;
            // let dDateEnd = oForm.sDateEnd_Start ? moment(oForm.sDateEnd_Start) : null;
            // let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(moment(dDateStart.startOf('month').format("YYYY MM DD"))) : null;
            // let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(moment(dDateEnd.endOf('month').format("YYYY MM DD"))) : null;
            // // let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "MMMM YYYY", "th");
            // // let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "MMMM YYYY", "th");

            // let obj = {
            //     isDelete: false,
            //     isEdit: false, 
            //     sID: nMaxID.toString(),
            //     nNo: nMaxID,
            //     nID: nMaxID,
            //     nProjectMonitorID: nProjectMonitorID,
            //     nActivityTypeID: EnumProjectMonitorType.Start,
            //     sActivity: oForm.sActivity_Start,
            //     // dStart: oForm.dProjectDateRange_Start && oForm.dProjectDateRange_Start[0] ? oForm.dProjectDateRange_Start[0] : null,
            //     // nStartDate: oForm.dProjectDateRange_Start && oForm.dProjectDateRange_Start[0] ? oForm.dProjectDateRange_Start[0].valueOf() : null,
            //     // dEnd: oForm.dProjectDateRange_Start && oForm.dProjectDateRange_Start[1] ? oForm.dProjectDateRange_Start[1] : null,
            //     // nEndDate: oForm.dProjectDateRange_Start && oForm.dProjectDateRange_Start[1] ? oForm.dProjectDateRange_Start[1].valueOf() : null,
            //     dStart: dDateStart, //oForm.sDateStart_Start ?? null,
            //     nStartDate: nUnixTimeStart, //oForm.sDateStart_Start ? oForm.sDateStart_Start.valueOf() : null,
            //     dEnd: dDateEnd, //oForm.sDateEnd_Start ?? null,
            //     nEndDate: nUnixTimeEnd, //oForm.sDateEnd_Start ? oForm.sDateEnd_Start.valueOf() : null,
            //     nProjectTeamID: nProjectTeamID,
            //     sProjectTeamName: sProjectTeamName,
            //     sDescription: oForm.sDescription_Start,
            // };
            // let nNo = 1;
            // let result = [...arrStart, obj];
            // result.forEach(f => f.nNo = nNo++);
            // let arrTable = result.filter(f => !f.isDelete);
            // setDataRowStart({
            //     ...dataRow,
            //     nDataLength: arrTable.length,
            //     arrRows: arrTable,
            // });
            // setnProjectMonitor_StartIDEdit(0);
            // setObjStartIDEdit(null);
            // setarrProjectMonitor_Start(result);
            // onClearFieldStart();
            //#endregion
        
            //#region New
            let nProjectMonitorID = 0;
            let dataRow = DataRowStart;
            let arrStart = DefaultArrayEmpty(arrProjectMonitor_Start);

            let sProjectTeamName = "";
            let nProjectTeamID = Convert.StringToInt(oForm.nProjectTeamID_Start);
            let ObjTeam = new LINQ<any>(arrDataProjectTeamID).FirstOrDefault(f=> f.value === nProjectTeamID) ?? null;
            if (ObjTeam) sProjectTeamName = ObjTeam.label;

            let dDateStart = oForm.sDateStart_Start ? moment(oForm.sDateStart_Start) : null;
            let dDateEnd = oForm.sDateEnd_Start ? moment(oForm.sDateEnd_Start) : null;
            let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(moment(dDateStart.startOf('month').format("YYYY MM DD"))) : null;
            let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(moment(dDateEnd.endOf('month').format("YYYY MM DD"))) : null;

            if (nProjectMonitor_StartIDEdit) //Edit
            {
                const oEditIndex = arrStart.findIndex((item) => item.nID === nProjectMonitor_StartIDEdit);
                if (oEditIndex !== -1) {
                    arrStart[oEditIndex].sActivity = oForm.sActivity_Start;
                    arrStart[oEditIndex].dStart = dDateStart;
                    arrStart[oEditIndex].nStartDate = nUnixTimeStart;
                    arrStart[oEditIndex].dEnd = dDateEnd;
                    arrStart[oEditIndex].nEndDate = nUnixTimeEnd;
                    arrStart[oEditIndex].nProjectTeamID = nProjectTeamID;
                    arrStart[oEditIndex].sProjectTeamName = sProjectTeamName;
                    arrStart[oEditIndex].sDescription = oForm.sDescription_Start;
                }
                let arrTable = arrStart.filter(f => !f.isDelete);
                setDataRowStart({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
            } 
            else //Add
            {           
                let nMaxID = new LINQ<any>(arrStart).Any() ? new LINQ<any>(arrStart).Max((m) => m.nID) + 1 : 1;
                let obj = {
                    isDelete: false,
                    isEdit: false, 
                    sID: nMaxID.toString(),
                    nNo: nMaxID,
                    nID: nMaxID,
                    nProjectMonitorID: nProjectMonitorID,
                    nActivityTypeID: EnumProjectMonitorType.Start,
                    sActivity: oForm.sActivity_Start,
                    dStart: dDateStart,
                    nStartDate: nUnixTimeStart,
                    dEnd: dDateEnd,
                    nEndDate: nUnixTimeEnd,
                    nProjectTeamID: nProjectTeamID,
                    sProjectTeamName: sProjectTeamName,
                    sDescription: oForm.sDescription_Start,
                };
                let nNo = 1;
                let result = [...arrStart, obj];
                result.forEach(f => f.nNo = nNo++);
                let arrTable = result.filter(f => !f.isDelete);
                setDataRowStart({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
                setarrProjectMonitor_Start(result);
            }
            setnProjectMonitor_StartIDEdit(0);
            setObjStartIDEdit(null);
            onClearFieldStart();
            //#endregion
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldStart = () => {
        Object.keys(formStart.getValues()).forEach((key) => {
            formStart.setValue(key, null);
            formStart.clearErrors(key);
        });
        // formStart.setValue("dProjectDateRange_Start", [null, null]);
        formStart.setValue("sDateStart_Start", _dStart);
        formStart.setValue("sDateEnd_Start", _dEnd);
    };

    const onEditStart = (ObjData, nModeID : EnumStatusMode) => {
        setnProjectMonitor_StartIDEdit(ObjData.nID);   
        let ObjStart = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nProjectMonitorID: ObjData.nProjectMonitorID,
            nActivityTypeID: ObjData.nActivityTypeID,
            sActivity: ObjData.sActivity,
            dStart: ObjData.dStart,
            nStartDate: ObjData.nStartDate,
            dEnd: ObjData.dEnd,
            nEndDate: ObjData.nEndDate,
            nProjectTeamID: ObjData.nProjectTeamID,
            sProjectTeamName: ObjData.nProjectTeamID,
            sDescription: ObjData.sDescription,
        };
        setObjStartIDEdit(ObjStart);
        formStart.setValue("sActivity_Start", ObjStart.sActivity);
        // formStart.setValue("dProjectDateRange_Start", [ObjStart.nStartDate ? moment(ObjStart.nStartDate) : null, ObjStart.nEndDate ? moment(ObjStart.nEndDate) : null]);
        formStart.setValue("sDateStart_Start", moment(ObjStart.nStartDate));
        formStart.setValue("sDateEnd_Start", moment(ObjStart.nEndDate));
        formStart.setValue("nProjectTeamID_Start", ObjStart.nProjectTeamID);
        formStart.setValue("sDescription_Start", ObjStart.sDescription);      

        document.getElementById("myDivStart").scrollIntoView({ behavior: "smooth" });    
    }

    const onDeleteStart = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrStartData: any[] = arrProjectMonitor_Start;
            let result = arrStartData.filter((f) => f.nID !== nID);
            let arrDelete = arrStartData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowStart({
                ...DataRowStart,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectMonitor_Start([...result, ...arrDelete]);
        });
    };
    //#endregion

    //#region Monitor Proceed
    const [nProjectMonitor_ProceedIDEdit, setnProjectMonitor_ProceedIDEdit] = useState(0);
    const [ObjProceedIDEdit, setObjProceedIDEdit] = useState(null);
    const [arrProjectMonitor_Proceed, setarrProjectMonitor_Proceed] = useState([]);
    const [DataRowProceed, setDataRowProceed] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formProceed = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sActivity_Proceed: null, 
            // dProjectDateRange_Proceed: [null, null],
            nProjectTeamID_Proceed: null,
            sDescription_Proceed: null,
            sDateStart_Proceed: null,
            sDateEnd_Proceed: null,
        } as any,
    });

    const dataColumnProceed: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Proceed_" + item.row.sID}
                                id={"btnDelete_Proceed_" + item.row.sID}
                                onClick={() => onDeleteProceed(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_Proceed_" + item.row.sID}
                                id="btnEdit"
                                onClick={() => onEditProceed(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Proceed_" + item.row.sID}
                            id="btnView"
                            onClick={() => onEditProceed(item.row, EnumStatusMode.View)}
                            // IsDisabled={isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "sActivity",
            headerName: "กิจกรรม",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "nStartDate",
            headerName: "ระยะเวลา",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                // let sDate = moment(item.row.nStartDate).format("DD MMMM YYYY") + " - " + moment(item.row.nEndDate).format("DD MMMM YYYY");
                let sDate = Convert.DateTimeToString(item.row.nStartDate, "MMMM YYYY", "th") + " - " + Convert.DateTimeToString(item.row.nEndDate, "MMMM YYYY", "th");
                return (sDate);
            },
        },      
        {
            field: "sProjectTeamName",
            headerName: "ผู้รับผิดชอบ/หน่วยงาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },       
    ];

    const onAddProceed = () => {
        let oForm = formProceed.getValues();
        let ObjDuplicate = arrProjectMonitor_Proceed.filter((f) => !f.isDelete && (nProjectMonitor_ProceedIDEdit !== 0 ? f.nID !== nProjectMonitor_ProceedIDEdit : true) && f.sActivity === oForm.sActivity);
        if ((ObjDuplicate || []).length === 0)
        {      
            //#region Old
            // let nProjectMonitorID = 0;
            // let dataRow = DataRowProceed;
            // let arrProceed = DefaultArrayEmpty(arrProjectMonitor_Proceed);
            // let nMaxID = new LINQ<any>(arrProceed).Any() ? new LINQ<any>(arrProceed).Max((m) => m.nID) + 1 : 1;
            // if (nProjectMonitor_ProceedIDEdit) {
            //     arrProceed = arrProceed.filter((f) => f.nID !== nProjectMonitor_ProceedIDEdit);
            //     nProjectMonitorID = arrProjectMonitor_Proceed.find((f) => f.nID === nProjectMonitor_ProceedIDEdit)?.nProjectMonitorID;
            //     nMaxID = nProjectMonitor_ProceedIDEdit;
            // }
            // let sProjectTeamName = "";
            // let nProjectTeamID = Convert.StringToInt(oForm.nProjectTeamID_Proceed);
            // let ObjTeam = new LINQ<any>(arrDataProjectTeamID).FirstOrDefault(f=> f.value === nProjectTeamID) ?? null;
            // if(ObjTeam) sProjectTeamName = ObjTeam.label;

            // let dDateStart = oForm.sDateStart_Proceed ? moment(oForm.sDateStart_Proceed) : null;
            // let dDateEnd = oForm.sDateEnd_Proceed ? moment(oForm.sDateEnd_Proceed) : null;
            // let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(moment(dDateStart.startOf('month').format("YYYY MM DD"))) : null;
            // let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(moment(dDateEnd.endOf('month').format("YYYY MM DD"))) : null;
            // // let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "MMMM YYYY", "th");
            // // let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "MMMM YYYY", "th");

            // let obj = {
            //     isDelete: false,
            //     isEdit: false, 
            //     sID: nMaxID.toString(),
            //     nNo: nMaxID,
            //     nID: nMaxID,
            //     nProjectMonitorID: nProjectMonitorID,
            //     nActivityTypeID: EnumProjectMonitorType.Proceed,
            //     sActivity: oForm.sActivity_Proceed,
            //     // dStart: oForm.dProjectDateRange_Proceed && oForm.dProjectDateRange_Proceed[0] ? oForm.dProjectDateRange_Proceed[0] : null,
            //     // nStartDate: oForm.dProjectDateRange_Proceed && oForm.dProjectDateRange_Proceed[0] ? oForm.dProjectDateRange_Proceed[0].valueOf() : null,
            //     // dEnd: oForm.dProjectDateRange_Proceed && oForm.dProjectDateRange_Proceed[1] ? oForm.dProjectDateRange_Proceed[1] : null,
            //     // nEndDate: oForm.dProjectDateRange_Proceed && oForm.dProjectDateRange_Proceed[1] ? oForm.dProjectDateRange_Proceed[1].valueOf() : null,
            //     dStart: dDateStart, //oForm.sDateStart_Proceed ?? null,
            //     nStartDate: nUnixTimeStart, //oForm.sDateStart_Proceed ? oForm.sDateStart_Proceed.valueOf() : null,
            //     dEnd: dDateEnd, //oForm.sDateEnd_Proceed ?? null,
            //     nEndDate: nUnixTimeEnd, //oForm.sDateEnd_Proceed ? oForm.sDateEnd_Proceed.valueOf() : null,
            //     nProjectTeamID: nProjectTeamID,
            //     sProjectTeamName: sProjectTeamName,
            //     sDescription: oForm.sDescription_Proceed,
            // };
            // let nNo = 1;
            // let result = [...arrProceed, obj];
            // result.forEach(f => f.nNo = nNo++);
            // let arrTable = result.filter(f => !f.isDelete);
            // setDataRowProceed({
            //     ...dataRow,
            //     nDataLength: arrTable.length,
            //     arrRows: arrTable,
            // });
            // setnProjectMonitor_ProceedIDEdit(0);
            // setObjProceedIDEdit(null);
            // setarrProjectMonitor_Proceed(result);
            // onClearFieldProceed();
            //#endregion

            //#region New
            let nProjectMonitorID = 0;
            let dataRow = DataRowProceed;
            let arrProceed = DefaultArrayEmpty(arrProjectMonitor_Proceed);

            let sProjectTeamName = "";
            let nProjectTeamID = Convert.StringToInt(oForm.nProjectTeamID_Proceed);
            let ObjTeam = new LINQ<any>(arrDataProjectTeamID).FirstOrDefault(f=> f.value === nProjectTeamID) ?? null;
            if(ObjTeam) sProjectTeamName = ObjTeam.label;

            let dDateStart = oForm.sDateStart_Proceed ? moment(oForm.sDateStart_Proceed) : null;
            let dDateEnd = oForm.sDateEnd_Proceed ? moment(oForm.sDateEnd_Proceed) : null;
            let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(moment(dDateStart.startOf('month').format("YYYY MM DD"))) : null;
            let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(moment(dDateEnd.endOf('month').format("YYYY MM DD"))) : null;

            if (nProjectMonitor_ProceedIDEdit) //Edit
            {
                const oEditIndex = arrProceed.findIndex((item) => item.nID === nProjectMonitor_ProceedIDEdit);
                if (oEditIndex !== -1) {
                    arrProceed[oEditIndex].sActivity = oForm.sActivity_Proceed;
                    arrProceed[oEditIndex].dStart = dDateStart;
                    arrProceed[oEditIndex].nStartDate = nUnixTimeStart;
                    arrProceed[oEditIndex].dEnd = dDateEnd;
                    arrProceed[oEditIndex].nEndDate = nUnixTimeEnd; 
                    arrProceed[oEditIndex].nProjectTeamID = nProjectTeamID;
                    arrProceed[oEditIndex].sProjectTeamName = sProjectTeamName;
                    arrProceed[oEditIndex].sDescription = oForm.sDescription_Proceed;
                }
                let arrTable = arrProceed.filter(f => !f.isDelete);
                setDataRowProceed({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
            } 
            else //Add
            {           
                let nMaxID = new LINQ<any>(arrProceed).Any() ? new LINQ<any>(arrProceed).Max((m) => m.nID) + 1 : 1;
                let obj = {
                    isDelete: false,
                    isEdit: false, 
                    sID: nMaxID.toString(),
                    nNo: nMaxID,
                    nID: nMaxID,
                    nProjectMonitorID: nProjectMonitorID,
                    nActivityTypeID: EnumProjectMonitorType.Proceed,
                    sActivity: oForm.sActivity_Proceed,
                    dStart: dDateStart,
                    nStartDate: nUnixTimeStart,
                    dEnd: dDateEnd,
                    nEndDate: nUnixTimeEnd, 
                    nProjectTeamID: nProjectTeamID,
                    sProjectTeamName: sProjectTeamName,
                    sDescription: oForm.sDescription_Proceed,
                };
                let nNo = 1;
                let result = [...arrProceed, obj];
                result.forEach(f => f.nNo = nNo++);
                let arrTable = result.filter(f => !f.isDelete);
                setDataRowProceed({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
                setarrProjectMonitor_Proceed(result);
            }
            setnProjectMonitor_ProceedIDEdit(0);
            setObjProceedIDEdit(null);
            onClearFieldProceed();
            //#endregion
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldProceed = () => {
        Object.keys(formProceed.getValues()).forEach((key) => {
            formProceed.setValue(key, null);
            formProceed.clearErrors(key);
        });
        // formProceed.setValue("dProjectDateRange_Proceed", [null, null]);
        formProceed.setValue("sDateStart_Proceed", _dStart);
        formProceed.setValue("sDateEnd_Proceed", _dEnd);       
    };

    const onEditProceed = (ObjData, nModeID : EnumStatusMode) => {
        setnProjectMonitor_ProceedIDEdit(ObjData.nID);   
        let ObjProceed = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nProjectMonitorID: ObjData.nProjectMonitorID,
            nActivityTypeID: ObjData.nActivityTypeID,
            sActivity: ObjData.sActivity,
            dStart: ObjData.dStart,
            nStartDate: ObjData.nStartDate,
            dEnd: ObjData.dEnd,
            nEndDate: ObjData.nEndDate,
            nProjectTeamID: ObjData.nProjectTeamID,
            sProjectTeamName: ObjData.nProjectTeamID,
            sDescription: ObjData.sDescription,
        };
        setObjProceedIDEdit(ObjProceed);
        formProceed.setValue("sActivity_Proceed", ObjProceed.sActivity);
        // formProceed.setValue("dProjectDateRange_Proceed", [ObjProceed.nStartDate ? moment(ObjProceed.nStartDate) : null, ObjProceed.nEndDate ? moment(ObjProceed.nEndDate) : null]);
        formProceed.setValue("sDateStart_Proceed", moment(ObjProceed.nStartDate));
        formProceed.setValue("sDateEnd_Proceed", moment(ObjProceed.nEndDate));
        formProceed.setValue("nProjectTeamID_Proceed", ObjProceed.nProjectTeamID);
        formProceed.setValue("sDescription_Proceed", ObjProceed.sDescription);

        document.getElementById("myDivProceed").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteProceed = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrProceedData: any[] = arrProjectMonitor_Proceed;
            let result = arrProceedData.filter((f) => f.nID !== nID);
            let arrDelete = arrProceedData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowProceed({
                ...DataRowProceed,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectMonitor_Proceed([...result, ...arrDelete]);
        });
    };
    //#endregion

    //#region Monitor End
    const [nProjectMonitor_EndIDEdit, setnProjectMonitor_EndIDEdit] = useState(0);
    const [ObjEndIDEdit, setObjEndIDEdit] = useState(null);
    const [arrProjectMonitor_End, setarrProjectMonitor_End] = useState([]);
    const [DataRowEnd, setDataRowEnd] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formEnd = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sActivity_End: null, 
            // dProjectDateRange_End: [null, null],
            nProjectTeamID_End: null,
            sDescription_End: null,
            sDateStart_End: null,
            sDateEnd_End: null,
        } as any,
    });

    const dataColumnEnd: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_End_" + item.row.sID}
                                id={"btnDelete_End_" + item.row.sID}
                                onClick={() => onDeleteEnd(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_End_" + item.row.sID}
                                id="btnEdit"
                                onClick={() => onEditEnd(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_End_" + item.row.sID}
                            id="btnView"
                            onClick={() => onEditEnd(item.row, EnumStatusMode.View)}
                            // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "sActivity",
            headerName: "กิจกรรม",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "nStartDate",
            headerName: "ระยะเวลา",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                // let sDate = moment(item.row.nStartDate).format("DD MMMM YYYY") + " - " + moment(item.row.nEndDate).format("DD MMMM YYYY");
                let sDate = Convert.DateTimeToString(item.row.nStartDate, "MMMM YYYY", "th") + " - " + Convert.DateTimeToString(item.row.nEndDate, "MMMM YYYY", "th");
                return (sDate);
            },
        },      
        {
            field: "sProjectTeamName",
            headerName: "ผู้รับผิดชอบ/หน่วยงาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },       
    ];

    const onAddEnd = () => {
        let oForm = formEnd.getValues();
        let ObjDuplicate = arrProjectMonitor_End.filter((f) => !f.isDelete && (nProjectMonitor_EndIDEdit !== 0 ? f.nID !== nProjectMonitor_EndIDEdit : true) && f.sActivity === oForm.sActivity);
        if ((ObjDuplicate || []).length === 0)
        {      
            //#region Old
            // let nProjectMonitorID = 0;
            // let dataRow = DataRowEnd;
            // let arrEnd = DefaultArrayEmpty(arrProjectMonitor_End);
            // let nMaxID = new LINQ<any>(arrEnd).Any() ? new LINQ<any>(arrEnd).Max((m) => m.nID) + 1 : 1;
            // if (nProjectMonitor_EndIDEdit) {
            //     arrEnd = arrEnd.filter((f) => f.nID !== nProjectMonitor_EndIDEdit);
            //     nProjectMonitorID = arrProjectMonitor_End.find((f) => f.nID === nProjectMonitor_EndIDEdit)?.nProjectMonitorID;
            //     nMaxID = nProjectMonitor_EndIDEdit;
            // }
            // let sProjectTeamName = "";
            // let nProjectTeamID = Convert.StringToInt(oForm.nProjectTeamID_End);
            // let ObjTeam = new LINQ<any>(arrDataProjectTeamID).FirstOrDefault(f=> f.value === nProjectTeamID) ?? null;
            // if(ObjTeam) sProjectTeamName = ObjTeam.label;

            // let dDateStart = oForm.sDateStart_End ? moment(oForm.sDateStart_End) : null;
            // let dDateEnd = oForm.sDateEnd_End ? moment(oForm.sDateEnd_End) : null;
            // let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(moment(dDateStart.startOf('month').format("YYYY MM DD"))) : null;
            // let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(moment(dDateEnd.endOf('month').format("YYYY MM DD"))) : null;
            // // let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "MMMM YYYY", "th");
            // // let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "MMMM YYYY", "th");

            // let obj = {
            //     isDelete: false,
            //     isEdit: false, 
            //     sID: nMaxID.toString(),
            //     nNo: nMaxID,
            //     nID: nMaxID,
            //     nProjectMonitorID: nProjectMonitorID,
            //     nActivityTypeID: EnumProjectMonitorType.End,
            //     sActivity: oForm.sActivity_End,
            //     // dStart: oForm.dProjectDateRange_End && oForm.dProjectDateRange_End[0] ? oForm.dProjectDateRange_End[0] : null,
            //     // nStartDate: oForm.dProjectDateRange_End && oForm.dProjectDateRange_End[0] ? oForm.dProjectDateRange_End[0].valueOf() : null,
            //     // dEnd: oForm.dProjectDateRange_End && oForm.dProjectDateRange_End[1] ? oForm.dProjectDateRange_End[1] : null,
            //     // nEndDate: oForm.dProjectDateRange_End && oForm.dProjectDateRange_End[1] ? oForm.dProjectDateRange_End[1].valueOf() : null,
            //     dStart: dDateStart, //oForm.sDateStart_End ?? null,
            //     nStartDate: nUnixTimeStart, //oForm.sDateStart_End ? oForm.sDateStart_End.valueOf() : null,
            //     dEnd: dDateEnd, //oForm.sDateEnd_End ?? null,
            //     nEndDate: nUnixTimeEnd, //oForm.sDateEnd_End ? oForm.sDateEnd_End.valueOf() : null,
            //     nProjectTeamID: nProjectTeamID,
            //     sProjectTeamName: sProjectTeamName,
            //     sDescription: oForm.sDescription_End,
            // };
            // let nNo = 1;
            // let result = [...arrEnd, obj];
            // result.forEach(f => f.nNo = nNo++);
            // let arrTable = result.filter(f => !f.isDelete);
            // setDataRowEnd({
            //     ...dataRow,
            //     nDataLength: arrTable.length,
            //     arrRows: arrTable,
            // });
            // setnProjectMonitor_EndIDEdit(0);
            // setObjEndIDEdit(null);
            // setarrProjectMonitor_End(result);
            // onClearFieldEnd();
            //#endregion

            //#region New
            let nProjectMonitorID = 0;
            let dataRow = DataRowEnd;
            let arrEnd = DefaultArrayEmpty(arrProjectMonitor_End);

            let sProjectTeamName = "";
            let nProjectTeamID = Convert.StringToInt(oForm.nProjectTeamID_End);
            let ObjTeam = new LINQ<any>(arrDataProjectTeamID).FirstOrDefault(f=> f.value === nProjectTeamID) ?? null;
            if(ObjTeam) sProjectTeamName = ObjTeam.label;

            let dDateStart = oForm.sDateStart_End ? moment(oForm.sDateStart_End) : null;
            let dDateEnd = oForm.sDateEnd_End ? moment(oForm.sDateEnd_End) : null;
            let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(moment(dDateStart.startOf('month').format("YYYY MM DD"))) : null;
            let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(moment(dDateEnd.endOf('month').format("YYYY MM DD"))) : null;

            if (nProjectMonitor_EndIDEdit) //Edit
            {
                const oEditIndex = arrEnd.findIndex((item) => item.nID === nProjectMonitor_EndIDEdit);
                if (oEditIndex !== -1) {
                    arrEnd[oEditIndex].sActivity = oForm.sActivity_End;
                    arrEnd[oEditIndex].dStart = dDateStart;
                    arrEnd[oEditIndex].nStartDate = nUnixTimeStart;
                    arrEnd[oEditIndex].dEnd = dDateEnd;
                    arrEnd[oEditIndex].nEndDate = nUnixTimeEnd;
                    arrEnd[oEditIndex].nProjectTeamID = nProjectTeamID;
                    arrEnd[oEditIndex].sProjectTeamName = sProjectTeamName;
                    arrEnd[oEditIndex].sDescription = oForm.sDescription_End;
                }
                let arrTable = arrEnd.filter(f => !f.isDelete);
                setDataRowEnd({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
            } 
            else //Add
            {            
                let nMaxID = new LINQ<any>(arrEnd).Any() ? new LINQ<any>(arrEnd).Max((m) => m.nID) + 1 : 1;                
                let obj = {
                    isDelete: false,
                    isEdit: false, 
                    sID: nMaxID.toString(),
                    nNo: nMaxID,
                    nID: nMaxID,
                    nProjectMonitorID: nProjectMonitorID,
                    nActivityTypeID: EnumProjectMonitorType.End,
                    sActivity: oForm.sActivity_End,
                    dStart: dDateStart, //oForm.sDateStart_End ?? null,
                    nStartDate: nUnixTimeStart, //oForm.sDateStart_End ? oForm.sDateStart_End.valueOf() : null,
                    dEnd: dDateEnd, //oForm.sDateEnd_End ?? null,
                    nEndDate: nUnixTimeEnd, //oForm.sDateEnd_End ? oForm.sDateEnd_End.valueOf() : null,
                    nProjectTeamID: nProjectTeamID,
                    sProjectTeamName: sProjectTeamName,
                    sDescription: oForm.sDescription_End,
                };
                let nNo = 1;
                let result = [...arrEnd, obj];
                result.forEach(f => f.nNo = nNo++);
                let arrTable = result.filter(f => !f.isDelete);
                setDataRowEnd({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
                setarrProjectMonitor_End(result);
            }
            setnProjectMonitor_EndIDEdit(0);
            setObjEndIDEdit(null);
            onClearFieldEnd();
            //#endregion
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldEnd = () => {
        Object.keys(formEnd.getValues()).forEach((key) => {
            formEnd.setValue(key, null);
            formEnd.clearErrors(key);
        });
        // formEnd.setValue("dProjectDateRange_End", [null, null]);
        formEnd.setValue("sDateStart_End", _dStart);
        formEnd.setValue("sDateEnd_End", _dEnd);
    };

    const onEditEnd = (ObjData, nModeID : EnumStatusMode) => {
        setnProjectMonitor_EndIDEdit(ObjData.nID);   
        let ObjEnd = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nProjectMonitorID: ObjData.nProjectMonitorID,
            nActivityTypeID: ObjData.nActivityTypeID,
            sActivity: ObjData.sActivity,
            dStart: ObjData.dStart,
            nStartDate: ObjData.nStartDate,
            dEnd: ObjData.dEnd,
            nEndDate: ObjData.nEndDate,
            nProjectTeamID: ObjData.nProjectTeamID,
            sProjectTeamName: ObjData.nProjectTeamID,
            sDescription: ObjData.sDescription,
        };
        setObjEndIDEdit(ObjEnd);
        formEnd.setValue("sActivity_End", ObjEnd.sActivity);
        // formEnd.setValue("dProjectDateRange_End", [ObjEnd.nStartDate ? moment(ObjEnd.nStartDate) : null, ObjEnd.nEndDate ? moment(ObjEnd.nEndDate) : null]);
        formEnd.setValue("sDateStart_End", moment(ObjEnd.nStartDate));
        formEnd.setValue("sDateEnd_End", moment(ObjEnd.nEndDate));
        formEnd.setValue("nProjectTeamID_End", ObjEnd.nProjectTeamID);
        formEnd.setValue("sDescription_End", ObjEnd.sDescription);

        document.getElementById("myDivEnd").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteEnd = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrEndData: any[] = arrProjectMonitor_End;
            let result = arrEndData.filter((f) => f.nID !== nID);
            let arrDelete = arrEndData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowEnd({
                ...DataRowEnd,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectMonitor_End([...result, ...arrDelete]);
        });
    };
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        if (nModeID === EnumSaveModeProject.Submit) {
            let isFile = false;
            let sMessageFileAll = "กรุณาเพิ่มข้อมูลอย่างน้อย 1 รายการ ในหัวข้อ";
            let isStart = arrProjectMonitor_Start.filter(f => !f.isDelete).length === 0;
            let isProceed = arrProjectMonitor_Proceed.filter(f => !f.isDelete).length === 0;
            let isEnd = arrProjectMonitor_End.filter(f => !f.isDelete).length === 0;
            if (isStart) {
                isFile = true;
                sMessageFileAll += "<br/> - 12.1 ระยะเริ่มต้นโครงการ";
            } 
            if (isProceed) {
                isFile = true;
                sMessageFileAll += "<br/> - 12.2 ระหว่างดําเนินการ";
            } 
            if (isEnd) {
                isFile = true;
                sMessageFileAll += "<br/> - 12.3 สิ้นสุดโครงการ";
            } 
            if(isFile) return DialogFn.Warning(sMessageFileAll);
        }

        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            isFastTrack: isFastTrack,
            nPanelID: EnumProjectPanel.Panel12,

            lstProjectMonitor_Start: arrProjectMonitor_Start, //105 ระยะเริ่มต้นโครงการ
            lstProjectMonitor_Proceed : arrProjectMonitor_Proceed,  //106 ระหว่างดําเนินการ
            lstProjectMonitor_End : arrProjectMonitor_End,  //107 สิ้นสุดโครงการ

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel12, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 12, isEdit: false});
                        setisChangePanel6(true);
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"12. การติดตามนิเทศโครงการ"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >    
            <Grid id={"myDivPanel12"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <Grid item xs={12} md={12} container spacing={2}>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item>
                            <Typography variant='h6' color={'#0000a5'}>การติดตามนิเทศโครงการ</Typography>
                        </Grid>
                        <Grid item>
                            <Tooltip placement={'right-end'} title={"ให้กำหนดการติดตามนิเทศโครงการตั้งแต่ระยะเริ่มต้นโครงการ ระหว่างดำเนินการ และสิ้นสุดโครงการ ทั้งนี้การนิเทศสามารถกำหนดให้หน่วยงานต้นสังกัดเป็นผู้นิเทศโครงการได้"}>
                                <ErrorIcon color='primary'/>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Divider />
                        </Grid>
                    </Grid>    
                    <Grid id={"myDivStart"} item xs={12} md={12} container spacing={2}>
                        <AccordionPanel
                            header={"12.1 ระยะเริ่มต้นโครงการ"}
                            isExpanded={false} 
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        >           
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...formStart}>
                                    <Grid item xs={12} md={12} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextBoxItem
                                                id={"sActivity_Start"}
                                                name={"sActivity_Start"}
                                                type={"text"}
                                                label={"ชื่อกิจกรรม"}
                                                required={true}
                                                maxLength={250}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1}>
                                            <Grid item xs={12} md={6}>
                                                {/* <DateRangePickerItem
                                                    id={"dProjectDateRange_Start"}
                                                    name={"dProjectDateRange_Start"}
                                                    labelStart={"ระยะเวลาเริ่มต้น"}
                                                    labelEnd={"ระยะเวลาสิ้นสุด"}                                
                                                    required={true}
                                                    minDate={_dStart}
                                                    maxDate={_dEnd}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                    format={"MMMM YYYY"}
                                                    view={["year", "month"]}
                                                /> */}
                                                {/* <DateRangePickerProject
                                                    nameStart={`sDateStart_Start`}
                                                    nameEnd={`sDateEnd_Start`}
                                                    labelStart={"ระยะเวลาเริ่มต้น"}
                                                    labelEnd={"ระยะเวลาสิ้นสุด"}    
                                                    required={true}
                                                    minDateStart={_dStart}
                                                    maxDateEnd={_dEnd}
                                                    view={["year", "month"]}
                                                    format={"MMMM YYYY"}
                                                /> */}
                                                <Grid container spacing={2}>
                                                    <Grid item xs={5.5}>
                                                        <DatePickerItem
                                                            id={'sDateStart_Start'}
                                                            name={'sDateStart_Start'}
                                                            label={"ระยะเวลาเริ่มต้น"}
                                                            fullWidth={true}
                                                            required={true}
                                                            // IsMonthYearPicker={true}
                                                            // minDate={_dStart}
                                                            // maxDate={_dEnd}
                                                            view={["year", "month"]}
                                                            format={"MMMM YYYY"}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                            minDate={_dStart}
                                                            maxDate={formStart.watch("sDateEnd_Start") || _dEnd}
                                                            defaultCalendarMonth={_dStart ? moment(_dStart).startOf('year').year(_dStart.getFullYear()) : null}
                                                            IsDisablePortal={true}
                                                        />
                                                    </Grid>
                                                    <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                        -
                                                    </Grid>
                                                    <Grid item xs={5.5}>
                                                        <DatePickerItem
                                                            id={'sDateEnd_Start'}
                                                            name={'sDateEnd_Start'}
                                                            label={"ระยะเวลาสิ้นสุด"}
                                                            fullWidth={true}
                                                            required={true}
                                                            view={["year", "month"]}
                                                            format={"MMMM YYYY"}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                            minDate={formStart.watch("sDateStart_Start") || _dStart}
                                                            maxDate={_dEnd}
                                                            defaultCalendarMonth={_dStart ? moment(_dStart).startOf('year').year(_dStart.getFullYear()) : null}
                                                            IsDisablePortal={true}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <SelectItem
                                                    id={"nProjectTeamID_Start"}
                                                    name={"nProjectTeamID_Start"}
                                                    label={"ผู้รับผิดชอบ/หน่วยงาน"}
                                                    required={true}
                                                    options={arrDataProjectTeamID}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextAreaItem
                                                id={"sDescription_Start"}
                                                name={"sDescription_Start"}
                                                label={"รายละเอียดเพิ่มเติม (ถ้ามี)"}
                                                required={false}
                                                maxLength={500}
                                                row={3}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                    </Grid> 
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {(nProjectMonitor_StartIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                            <BtnAdd id={"btnAdd_Table_Start"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่ม"} onClick={formStart.handleSubmit((e) => onAddStart(),(err) => console.log("err", err))} />
                                            :
                                            <>
                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_Table_Start"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formStart.handleSubmit((e) => onAddStart(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                }
                                                {nProjectMonitor_StartIDEdit !== 0 &&
                                                <Grid item>
                                                    <BtnCancel id={"btnCancel_Table_Start"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectMonitor_StartIDEdit(0); setObjStartIDEdit(null); onClearFieldStart(); }} />
                                                </Grid>
                                                }         
                                            </>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                        <DataGrid
                                            sTableID='TB_ProjectMonitor_Start'
                                            columns={dataColumnStart}
                                            rows={DataRowStart}
                                            isShowColomnTool={false}
                                            isHiddenToolHead={true}
                                            isShowCheckBox={false}
                                            isHiddenPagination={false}
                                        />
                                    </Grid>
                                </FormProvider> 
                            </Grid> 
                        </AccordionPanel>  
                    </Grid>            
                    <Grid id={"myDivProceed"} item xs={12} md={12} container spacing={2}>
                        <AccordionPanel
                            header={"12.2 ระหว่างดําเนินการ"}
                            isExpanded={false} 
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        >           
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...formProceed}>
                                    <Grid item xs={12} md={12} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextBoxItem
                                                id={"sActivity_Proceed"}
                                                name={"sActivity_Proceed"}
                                                type={"text"}
                                                label={"ชื่อกิจกรรม"}
                                                required={true}
                                                maxLength={250}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1}>
                                            <Grid item xs={12} md={6}>
                                                {/* <DateRangePickerItem
                                                    id={"dProjectDateRange_Proceed"}
                                                    name={"dProjectDateRange_Proceed"}
                                                    labelStart={"ระยะเวลาเริ่มต้น"}
                                                    labelEnd={"ระยะเวลาสิ้นสุด"}                                
                                                    required={true}
                                                    minDate={_dStart}
                                                    maxDate={_dEnd}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                    format={"MMMM YYYY"}
                                                    view={["year", "month"]}
                                                /> */}
                                                {/* <DateRangePickerProject
                                                    nameStart={`sDateStart_Proceed`}
                                                    nameEnd={`sDateEnd_Proceed`}
                                                    labelStart={"ระยะเวลาเริ่มต้น"}
                                                    labelEnd={"ระยะเวลาสิ้นสุด"}    
                                                    required={true}
                                                    minDateStart={_dStart}
                                                    maxDateEnd={_dEnd}
                                                    view={["year", "month"]}
                                                    format={"MMMM YYYY"}
                                                /> */}
                                                <Grid container spacing={2}>
                                                    <Grid item xs={5.5}>
                                                        <DatePickerItem
                                                            id={'sDateStart_Proceed'}
                                                            name={'sDateStart_Proceed'}
                                                            label={"ระยะเวลาเริ่มต้น"}
                                                            fullWidth={true}
                                                            required={true}
                                                            view={["year", "month"]}
                                                            format={"MMMM YYYY"}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                            minDate={_dStart}
                                                            maxDate={formProceed.watch("sDateEnd_Proceed") || _dEnd}
                                                            defaultCalendarMonth={_dStart ? moment(_dStart).startOf('year').year(_dStart.getFullYear()) : null}
                                                            IsDisablePortal={true}
                                                        />
                                                    </Grid>
                                                    <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                        -
                                                    </Grid>
                                                    <Grid item xs={5.5}>
                                                        <DatePickerItem
                                                            id={'sDateEnd_Proceed'}
                                                            name={'sDateEnd_Proceed'}
                                                            label={"ระยะเวลาสิ้นสุด"}
                                                            fullWidth={true}
                                                            required={true}
                                                            view={["year", "month"]}
                                                            format={"MMMM YYYY"}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                            minDate={formProceed.watch("sDateStart_Proceed") || _dStart}
                                                            maxDate={_dEnd}
                                                            defaultCalendarMonth={_dStart ? moment(_dStart).startOf('year').year(_dStart.getFullYear()) : null}
                                                            IsDisablePortal={true}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <SelectItem
                                                    id={"nProjectTeamID_Proceed"}
                                                    name={"nProjectTeamID_Proceed"}
                                                    label={"ผู้รับผิดชอบ/หน่วยงาน"}
                                                    required={true}
                                                    options={arrDataProjectTeamID}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextAreaItem
                                                id={"sDescription_Proceed"}
                                                name={"sDescription_Proceed"}
                                                label={"รายละเอียดเพิ่มเติม (ถ้ามี)"}
                                                required={false}
                                                maxLength={500}
                                                row={3}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                    </Grid> 
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {(nProjectMonitor_ProceedIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                            <BtnAdd id={"btnAdd_Table_Proceed"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่ม"} onClick={formProceed.handleSubmit((e) => onAddProceed(),(err) => console.log("err", err))} />
                                            :
                                            <>
                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_Table_Proceed"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formProceed.handleSubmit((e) => onAddProceed(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                }
                                                {nProjectMonitor_ProceedIDEdit !== 0 &&
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Table_Proceed"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectMonitor_ProceedIDEdit(0); setObjProceedIDEdit(null); onClearFieldProceed(); }} />
                                                    </Grid>
                                                }             
                                            </>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                        <DataGrid
                                            sTableID='TB_ProjectMonitor_Proceed'
                                            columns={dataColumnProceed}
                                            rows={DataRowProceed}
                                            isShowColomnTool={false}
                                            isHiddenToolHead={true}
                                            isShowCheckBox={false}
                                            isHiddenPagination={false}
                                        />
                                    </Grid>
                                </FormProvider> 
                            </Grid>  
                        </AccordionPanel>  
                    </Grid>    
                    <Grid id={"myDivEnd"} item xs={12} md={12} container spacing={2}>
                        <AccordionPanel
                            header={"12.3 สิ้นสุดโครงการ"}
                            isExpanded={false} 
                            color="white"
                            bgColor="rgb(102,151,245)"
                            background="#e79a09"
                            expandIconColor="white"
                            borderColor="1px solid #e79a09"
                            borderRadius="20px !important"
                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        >
                            <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                                <FormProvider {...formEnd}>
                                    <Grid item xs={12} md={12} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextBoxItem
                                                id={"sActivity_End"}
                                                name={"sActivity_End"}
                                                type={"text"}
                                                label={"ชื่อกิจกรรม"}
                                                required={true}
                                                maxLength={250}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1}>
                                            <Grid item xs={12} md={6}>
                                                {/* <DateRangePickerItem
                                                    id={"dProjectDateRange_End"}
                                                    name={"dProjectDateRange_End"}
                                                    labelStart={"ระยะเวลาเริ่มต้น"}
                                                    labelEnd={"ระยะเวลาสิ้นสุด"}                                
                                                    required={true}
                                                    minDate={_dStart}
                                                    maxDate={_dEnd}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                    format={"MMMM YYYY"}
                                                    view={["year", "month"]}
                                                /> */}
                                                {/* <DateRangePickerProject
                                                    nameStart={`sDateStart_End`}
                                                    nameEnd={`sDateEnd_End`}
                                                    labelStart={"ระยะเวลาเริ่มต้น"}
                                                    labelEnd={"ระยะเวลาสิ้นสุด"}
                                                    required={true}
                                                    minDateStart={_dStart}
                                                    maxDateEnd={_dEnd}
                                                    view={["year", "month"]}
                                                    format={"MMMM YYYY"}
                                                /> */}
                                                <Grid container spacing={2}>
                                                    <Grid item xs={5.5}>
                                                        <DatePickerItem
                                                            id={'sDateStart_End'}
                                                            name={'sDateStart_End'}
                                                            label={"ระยะเวลาเริ่มต้น"}
                                                            fullWidth={true}
                                                            required={true}
                                                            view={["year", "month"]}
                                                            format={"MMMM YYYY"}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                            minDate={_dStart}
                                                            maxDate={formEnd.watch("sDateEnd_End") || _dEnd}
                                                            defaultCalendarMonth={_dStart ? moment(_dStart).startOf('year').year(_dStart.getFullYear()) : null}
                                                            IsDisablePortal={true}
                                                        />
                                                    </Grid>
                                                    <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                        -
                                                    </Grid>
                                                    <Grid item xs={5.5}>
                                                        <DatePickerItem
                                                            id={'sDateEnd_End'}
                                                            name={'sDateEnd_End'}
                                                            label={"ระยะเวลาสิ้นสุด"}
                                                            fullWidth={true}
                                                            required={true}
                                                            view={["year", "month"]}
                                                            format={"MMMM YYYY"}
                                                            disabled={!isPermission || isEditSecretary === false}
                                                            minDate={formEnd.watch("sDateStart_End") || _dStart}
                                                            maxDate={_dEnd}
                                                            defaultCalendarMonth={_dStart ? moment(_dStart).startOf('year').year(_dStart.getFullYear()) : null}
                                                            IsDisablePortal={true}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <SelectItem
                                                    id={"nProjectTeamID_End"}
                                                    name={"nProjectTeamID_End"}
                                                    label={"ผู้รับผิดชอบ/หน่วยงาน"}
                                                    required={true}
                                                    options={arrDataProjectTeamID}
                                                    disabled={!isPermission || isEditSecretary === false}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextAreaItem
                                                id={"sDescription_End"}
                                                name={"sDescription_End"}
                                                label={"รายละเอียดเพิ่มเติม (ถ้ามี)"}
                                                required={false}
                                                maxLength={500}
                                                row={3}
                                                disabled={!isPermission || isEditSecretary === false}
                                            />
                                        </Grid>
                                    </Grid> 
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {(nProjectMonitor_EndIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                            <BtnAdd id={"btnAdd_Table_End"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่ม"} onClick={formEnd.handleSubmit((e) => onAddEnd(),(err) => console.log("err", err))} />
                                            :
                                            <>
                                                {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_Table_End"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formEnd.handleSubmit((e) => onAddEnd(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                }
                                                {nProjectMonitor_EndIDEdit !== 0 &&
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Table_End"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectMonitor_EndIDEdit(0); setObjEndIDEdit(null); onClearFieldEnd(); }} />
                                                    </Grid>
                                                }                 
                                            </>
                                        }
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                        <DataGrid
                                            sTableID='TB_ProjectMonitor_End'
                                            columns={dataColumnEnd}
                                            rows={DataRowEnd}
                                            isShowColomnTool={false}
                                            isHiddenToolHead={true}
                                            isShowCheckBox={false}
                                            isHiddenPagination={false}
                                        />
                                    </Grid>
                                </FormProvider> 
                            </Grid>
                        </AccordionPanel>  
                    </Grid>    
                    {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                        <></>
                        :   
                        (isPermission === true &&
                            (isModeSecretary !== true ?
                                <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                    {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                        <Grid item>
                                            <BtnDraft id={"btnDraft_Panel12"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                        </Grid>
                                    }
                                    <Grid item>
                                        <BtnSendRequest id={"btnSend_Panel12"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => {handleSubmit(EnumSaveModeProject.Submit) }} />
                                    </Grid> 
                                </Grid> 
                            : 
                                (isModeSecretary === true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {isEditSecretary === false ?
                                            <Grid item>
                                                <BtnEdit id={"btnEdit_Panel12"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivPanel12").scrollIntoView({ behavior: "smooth" });}} />
                                            </Grid>
                                            :
                                            <>
                                                <Grid item>
                                                    <BtnCancel id={"btnCancel_Panel12"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                </Grid>
                                                <Grid item>
                                                    <BtnSendRequest id={"btnSend_Panel12"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                                </Grid>
                                            </>
                                        }   
                                    </Grid>
                                    : <></>
                                )
                            )
                        )
                    }         
                </Grid>      
            </Grid>
        </AccordionPanel>
    )
}
export default Panel12;
